import React, { useState } from "react";
import { SectionTitle } from "./_components/SectionTitle";
import { CustomAccordion } from "./_components/CustomAccordion";
import {
  Breadcrumb,
  BreadcrumbEllipsis,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "src/components/ui/breadcrumb";
import { Link } from "react-router-dom";
import { Card } from "../../components/ui/card";
import { AnimatePresence, motion } from "framer-motion";
import { Mail, MapPin, PhoneCall, SearchIcon, Send } from "lucide-react";
import { Input } from "../../components/ui/input";
import { Avatar, Tooltip } from "antd";
import { cn } from "../../lib/utils";
import { UrlImage } from "../../lib/api";
import { CourseCard } from "../../components/CourseCard";
import { Separator } from "src/components/ui/separator";
import { Textarea } from "src/components/ui/textarea";
import MainButton from "../../components/MainButton";

export default function MainContactUs() {
  const [showSearch, setShowSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  return (
    <div className="space-y-20 max-w-7xl mx-auto px-4 mt-14">
      <div className="space-y-6 text-right">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">الصفحة الرئيسية</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbSeparator />

            <BreadcrumbItem>
              <BreadcrumbPage className="font-semibold">
                تواصل معنا
              </BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <Card className="px-4 bg-gradient-to-r from-blue-600 to-blue-500 relative overflow-hidden">
          <div className="h-40 flex flex-col items-center justify-center">
            {/* عناصر زخرفية */}
            <div className="absolute -right-12 -top-12 h-40 w-40 rounded-full bg-blue-400 opacity-20"></div>
            <div className="absolute -bottom-12 -left-12 h-40 w-40 rounded-full bg-blue-800 opacity-20"></div>

            <div className="relative flex flex-col items-center justify-center gap-4">
              <div className="px-4 py-2 bg-white text-blue-600 uppercase rounded-xl font-semibold">
                راسلنا
              </div>
              <div className="text-4xl font-semibold text-white">
                ابقَ على تواصل
              </div>
            </div>
          </div>
        </Card>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 h-full text-right">
        {/* الجهة اليمنى (النموذج) */}
        <div className="col-span-2 flex flex-col gap-4">
          <div>
            <div className="font-bold text-3xl">تحدث معنا</div>
            <div className="text-base text-muted-foreground">
              تواصل معنا عبر نموذج الاستفسار أو من خلال معلومات التواصل أدناه
            </div>
          </div>

          <Separator className="mb-5" />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* Form */}
            <div className="flex flex-col gap-2 col-span-2 md:col-span-1">
              <label htmlFor="fname" className="font-medium text-sm">
                الاسم الأول
              </label>
              <Input id="fname" name="fname" placeholder="محمد" />
            </div>
            <div className="flex flex-col gap-2 col-span-2 md:col-span-1">
              <label htmlFor="lname" className="font-medium text-sm">
                اسم العائلة
              </label>
              <Input id="lname" name="lname" placeholder="أحمد" />
            </div>
            <div className="flex flex-col gap-2 col-span-2">
              <label htmlFor="email" className="font-medium text-sm">
                البريد الإلكتروني
              </label>
              <Input
                id="email"
                name="email"
                placeholder="mohamed@example.com"
              />
            </div>
            <div className="flex flex-col gap-2 col-span-2 flex-grow">
              <label htmlFor="message" className="font-medium text-sm">
                الرسالة
              </label>
              <Textarea
                id="message"
                name="message"
                placeholder="اكتب شيئًا..."
                className="flex-1 min-h-[200px] resize-none"
              />
            </div>

            <MainButton title="إرسال" Icon={Send} />
          </div>
        </div>

        {/* Personal data */}
        <div className="flex flex-col justify-between h-full">
          <img
            src="person2.jpg"
            alt="شخص"
            className="object-cover object-top rounded-xl shadow-md h-full w-full max-h-[350px]"
          />

          <div className="space-y-4 mt-4">
            <div className="flex items-center gap-2">
              <div className="p-2 rounded-lg text-blue-600 border">
                <Mail />
              </div>
              <div className="flex flex-col">
                <p className="font-bold">البريد الإلكتروني</p>
                <p className="text-sm text-muted-foreground">
                  john@example.com
                </p>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <div className="p-2 rounded-lg text-blue-600 border">
                <PhoneCall />
              </div>
              <div className="flex flex-col">
                <p className="font-bold">رقم الهاتف</p>
                <p className="text-sm text-muted-foreground">
                  EG +012 34567890
                </p>
              </div>
            </div>

            <div className="flex items-center gap-2">
              <div className="p-2 rounded-lg text-blue-600 border">
                <MapPin />
              </div>
              <div className="flex flex-col">
                <p className="font-bold">الموقع</p>
                <p className="text-sm text-muted-foreground">سخا، كفر الشيخ</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
